import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  domain: localStorage.getItem("domain")
    ? JSON.parse(localStorage.getItem("domain"))
    : null,
  subdomain: localStorage.getItem("subdomain")
    ? JSON.parse(localStorage.getItem("subdomain"))
    : null,
  topic: localStorage.getItem("topic")
    ? JSON.parse(localStorage.getItem("topic"))
    : null,
  subtopic: localStorage.getItem("subtopic")
    ? JSON.parse(localStorage.getItem("subtopic"))
    : null,
};

const optionsSlice = createSlice({
  name: "options",
  initialState,
  reducers: {
    setDomain: (state, action) => {
      state.domain = action.payload;
      localStorage.setItem("domain", JSON.stringify(action.payload));
    },
    setSubdomain: (state, action) => {
      state.subdomain = action.payload;
      localStorage.setItem("subdomain", JSON.stringify(action.payload));
    },
    unsetSubdomain: (state) => {
      state.subdomain = null;
      localStorage.removeItem("subdomain");
    },
    setTopic: (state, action) => {
      state.topic = action.payload;
      localStorage.setItem("topic", JSON.stringify(action.payload));
    },
    unsetTopic: (state) => {
      state.topic = null;
      localStorage.removeItem("topic");
    },
    setSubtopic: (state, action) => {
      state.subtopic = action.payload;
      localStorage.setItem("subtopic", JSON.stringify(action.payload));
    },
    unsetSubtopic: (state) => {
      state.subtopic = null;
      localStorage.removeItem("subtopic");
    },
    unsetOptions: (state) => {
      state.domain = null;
      state.subdomain = null;
      state.topic = null;
      state.subtopic = null;
      localStorage.removeItem("domain");
      localStorage.removeItem("subdomain");
      localStorage.removeItem("topic");
      localStorage.removeItem("subtopic");
    },

    // clearAuth: (state) => {
    //   state.user = null;
    //   state.accessToken = null;
    //   localStorage.clear();
    // },
  },
});

export const { setDomain, setSubdomain,unsetSubdomain, setTopic,unsetTopic, setSubtopic,unsetSubtopic,unsetOptions } =
  optionsSlice.actions;
export const selectOptions = (state) => state.options;
export default optionsSlice.reducer;